<div class="card mwp-placeholder w-50">
    <div class="card-body placeholder-glow">
        <div class="card-title">
            <span class="placeholder col-4 placeholder-lg p-3"></span>
        </div>
        <div class="card-text">
            <span class="placeholder col-7 me-1"></span>
            <span class="placeholder col-4"></span>
            <span class="placeholder col-4 me-1"></span>
            <span class="placeholder col-6"></span>
            <span class="placeholder col-8"></span>
        </div>
    </div>
</div>